import React, { useEffect } from 'react';
import Snackbar from '@material-ui/core/Snackbar';
import Slide from '@material-ui/core/Slide';
import { Trans } from 'react-i18next';

const SlideTransition = props => <Slide {...props} direction="down" />;

const SuccessMessage = ({
  t,
  i18nKey,
  tParams,
  className = '',
  vertical = 'top',
  horizontal = 'right',
  message,
  open,
  messageKey,
  setOpen,
  type,
}) => {
  const finalMessage = !!t ? (
    <Trans t={t} i18nKey={i18nKey}>
      {tParams}
    </Trans>
  ) : (
    message
  );

  useEffect(() => {
    const snackBars = document.querySelectorAll('.react-notification');
    if (snackBars.length > 1) {
      for (let i = 1; i < snackBars.length; i++) {
        snackBars[i].style.top = snackBars[i - 1].offsetTop + snackBars[i - 1].offsetHeight + 10 + 'px';
      }
    }
  });
  return (
    <Snackbar
      anchorOrigin={{ vertical, horizontal }}
      open={open}
      onClose={(e, action) => {
        if (action == 'timeout') setOpen(false);
      }}
      TransitionComponent={SlideTransition}
      message={finalMessage}
      transitionDuration={1000}
      key={messageKey}
      autoHideDuration={5000}
      className={`${className} react-notification ${type ? `react-notification-${type}` : ''}`}
      onClick={() => setOpen(false)}
    />
  );
};

export default SuccessMessage;